import { VehicleType } from '/@/modules/asset/enums/VehicleType';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step613645Meta extends BaseModel {
  /**
   * @var {?bool}
   */
  hasVehicles;

  /**
   * @var {?VehicleType[]}
   */
  vehicleTypes;

  /**
   * @var {?number}
   */
  passengerCarsCount;

  /**
   * @var {?number}
   */
  recreationalVehiclesCount;

  /**
   * @var {?number}
   */
  recreationalProductsCount;

  constructor(model = {}) {
    super();
    this.hasVehicles = model.hasVehicles;
    this.vehicleTypes = model.vehicleTypes ?? [];
    this.passengerCarsCount = model.passengerCarsCount;
    this.recreationalVehiclesCount = model.recreationalVehiclesCount;
    this.recreationalProductsCount = model.recreationalProductsCount;
  }

  resetVehicleTypes() {
    this.vehicleTypes = null;
    this.passengerCarsCount = 0;
    this.recreationalVehiclesCount = 0;
    this.recreationalProductsCount = 0;
  }

  getCountKey(key) {
    if (key === VehicleType.PASSENGER_CARS.key) {
      return 'passengerCarsCount';
    }
    if (key === VehicleType.RECREATIONAL_VEHICLES.key) {
      return 'recreationalVehiclesCount';
    }
    if (key === VehicleType.RECREATIONAL_PRODUCTS.key) {
      return 'recreationalProductsCount';
    }
  }
}
